<template>
  <div class="relative z-10" aria-labelledby="modal-title" role="dialog" aria-modal="true">
    <div class="fixed inset-0 bg-gray-900 bg-opacity-75 transition-opacity"></div>
    <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
      <div class="flex min-h-full items-center justify-center p-4">
        <div class="relative transform overflow-hidden rounded-lg bg-gray-800 text-white shadow-xl transition-all sm:max-w-3xl w-full">
          <div class="p-5 h-96 overflow-auto">
            <!-- หัวข้อและปุ่มปิด -->
            <div class="flex justify-between items-center mb-6">
              <h3 class="text-xl font-semibold text-indigo-300">เพิ่มพ่อค้าเร่ใหม่</h3>
              <button @click="$emit('cancelModal')" class="text-gray-400 hover:text-white">
                <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            <!-- ฟอร์ม -->
            <form @submit.prevent="handleAddMerchant">
              <div class="space-y-4 mb-6">
                <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <div>
                    <label class="block text-sm font-medium mb-1 text-gray-300">ชื่อพ่อค้าเร่</label>
                    <input 
                      v-model="newMerchant.name" 
                      type="text" 
                      class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                      required
                    >
                  </div>
                  <div>
                    <label class="block text-sm font-medium mb-1 text-gray-300">ระดับความหายาก</label>
                    <select 
                      v-model.number="newMerchant.rarity" 
                      class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                      required
                    >
                      <option value="" disabled>เลือกระดับความหายาก</option>
                      <option value="1">1</option>
                      <option value="2">2</option>
                      <option value="3">3</option>
                      <option value="4">4</option>
                      <option value="5">5</option>
                    </select>
                  </div>
                  <div>
                    <label class="block text-sm font-medium mb-1 text-gray-300">ลิงค์รูปภาพพ่อค้าเร่</label>
                    <input 
                      v-model="newMerchant.img" 
                      type="url" 
                      class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                      placeholder="https://example.com/image.jpg"
                      required
                    >
                  </div>
                  <div>
                    <label class="block text-sm font-medium mb-1 text-gray-300">ลิงค์รูปหน้าปกติ</label>
                    <input 
                      v-model="newMerchant.normalFace" 
                      type="url" 
                      class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                      placeholder="https://example.com/normal-face.jpg"
                    >
                  </div>
                  <div>
                    <label class="block text-sm font-medium mb-1 text-gray-300">ลิงค์รูปหน้าที่โมโห</label>
                    <input 
                      v-model="newMerchant.angryFace" 
                      type="url" 
                      class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                      placeholder="https://example.com/angry-face.jpg"
                    >
                  </div>
                </div>

                <!-- คำพูดที่พ่อค้าชอบพูด -->
                <div class="space-y-4 mb-6">
                  <h4 class="text-lg font-medium text-gray-300">คำพูดที่พ่อค้าชอบพูด</h4>
                  <div v-for="(phrase, index) in newMerchant.phrases" :key="index" class="grid grid-cols-12 items-center gap-3 animate-fade-in">
                    <div class="col-span-10">
                      <input 
                        v-model="newMerchant.phrases[index]" 
                        type="text" 
                        placeholder="คำพูด"
                        class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                      >
                    </div>
                    <div class="col-span-2">
                      <button 
                        v-if="index > 0"
                        @click="removePhrase(index)"
                        type="button"
                        class="w-full px-2 py-1.5 bg-red-600 rounded-lg hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 text-white transition duration-200"
                        aria-label="ลบคำพูด"
                      >
                        ลบ
                      </button>
                    </div>
                  </div>
                  <div class="flex gap-3 mt-3">
                    <button 
                      @click="addPhrase"
                      type="button"
                      class="px-4 py-2 bg-green-600 rounded-lg hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 text-white transition duration-200"
                    >
                      + เพิ่มคำพูด
                    </button>
                  </div>
                </div>

                <!-- รายการสินค้าที่ขาย -->
                <div class="space-y-4 mb-6">
                  <h4 class="text-lg font-medium text-gray-300">รายการสินค้าที่ขาย</h4>
                  <div v-for="(item, index) in newMerchant.items" :key="index" class="grid grid-cols-12 items-center gap-3 animate-fade-in">
                    <div class="col-span-4">
                      <input 
                        v-model="item.name" 
                        type="text" 
                        placeholder="ชื่อไอเทม"
                        class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                      >
                    </div>
                    <div class="col-span-2">
                      <input 
                        v-model.number="item.price" 
                        type="number" 
                        min="0"
                        placeholder="ราคา"
                        class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                      >
                    </div>
                    <div class="col-span-3">
                      <select 
                        v-model="item.currency" 
                        class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                      >
                        <option value="silver">Silver</option>
                        <option value="gold">Gold</option>
                        <option value="diamond">Diamond</option>
                      </select>
                    </div>
                    <div class="col-span-2 flex items-center">
                      <label class="flex items-center text-sm text-gray-300">
                        <input 
                          v-model="item.transferable" 
                          type="checkbox" 
                          class="mr-2 bg-gray-700 border-gray-600 focus:ring-indigo-500"
                        >
                        โอนได้
                      </label>
                    </div>
                    <div class="col-span-1">
                      <button 
                        v-if="index > 0"
                        @click="removeItem(index)"
                        type="button"
                        class="w-full px-2 py-1.5 bg-red-600 rounded-lg hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 text-white transition duration-200"
                        aria-label="ลบไอเทม"
                      >
                        ลบ
                      </button>
                    </div>
                  </div>
                  <div class="flex gap-3 mt-3">
                    <button 
                      @click="addItem"
                      type="button"
                      class="px-4 py-2 bg-green-600 rounded-lg hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 text-white transition duration-200"
                    >
                      + เพิ่มไอเทม
                    </button>
                  </div>
                </div>

                <!-- สถานที่ที่พบ -->
                <div class="space-y-4 mb-6">
                  <h4 class="text-lg font-medium text-gray-300">สถานที่ที่พบ</h4>
                  <div v-for="(location, index) in newMerchant.locations" :key="index" class="grid grid-cols-12 items-center gap-3 animate-fade-in">
                    <div class="col-span-10">
                      <input 
                        v-model="newMerchant.locations[index]" 
                        type="text" 
                        placeholder="ชื่อสถานที่"
                        class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                      >
                    </div>
                    <div class="col-span-2">
                      <button 
                        v-if="index > 0"
                        @click="removeLocation(index)"
                        type="button"
                        class="w-full px-2 py-1.5 bg-red-600 rounded-lg hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 text-white transition duration-200"
                        aria-label="ลบสถานที่"
                      >
                        ลบ
                      </button>
                    </div>
                  </div>
                  <div class="flex gap-3 mt-3">
                    <button 
                      @click="addLocation"
                      type="button"
                      class="px-4 py-2 bg-green-600 rounded-lg hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 text-white transition duration-200"
                    >
                      + เพิ่มสถานที่
                    </button>
                  </div>
                </div>

                <!-- อนุญาตให้ต่อสู้เพื่อปล้น -->
                <div class="space-y-4 mb-6">
                  <label class="flex items-center">
                    <input 
                      v-model="newMerchant.allowRob" 
                      type="checkbox" 
                      class="mr-2 bg-gray-700 border-gray-600 focus:ring-indigo-500"
                    >
                    <span class="text-sm font-medium text-gray-300">อนุญาตให้ต่อสู้เพื่อปล้น</span>
                  </label>
                  <div v-if="newMerchant.allowRob" class="grid grid-cols-3 gap-4">
                    <div>
                      <label class="block text-sm font-medium mb-1 text-gray-300">Silver ที่ได้รับ</label>
                      <input 
                        v-model.number="newMerchant.robRewards.silver" 
                        type="number" 
                        min="0"
                        class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                      >
                    </div>
                    <div>
                      <label class="block text-sm font-medium mb-1 text-gray-300">Gold ที่ได้รับ</label>
                      <input 
                        v-model.number="newMerchant.robRewards.gold" 
                        type="number" 
                        min="0"
                        class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                      >
                    </div>
                    <div>
                      <label class="block text-sm font-medium mb-1 text-gray-300">Diamond ที่ได้รับ</label>
                      <input 
                        v-model.number="newMerchant.robRewards.diamond" 
                        type="number" 
                        min="0"
                        class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                      >
                    </div>
                  </div>
                </div>

                <!-- ค่าสถานะ (แสดงเฉพาะเมื่ออนุญาตให้ปล้น) -->
                <div v-if="newMerchant.allowRob" class="space-y-4 mb-6">
                  <h4 class="text-lg font-medium text-gray-300">ค่าสถานะ</h4>
                  <div class="grid grid-cols-2 sm:grid-cols-6 gap-4">
                    <div>
                      <label class="block text-sm font-medium mb-1 text-gray-300">Stamina</label>
                      <input
                        v-model.number="newMerchant.stats.stamina"
                        type="number"
                        min="0"
                        class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                      />
                    </div>
                    <div>
                      <label class="block text-sm font-medium mb-1 text-gray-300">Strength</label>
                      <input
                        v-model.number="newMerchant.stats.str"
                        type="number"
                        min="0"
                        class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                      />
                    </div>
                    <div>
                      <label class="block text-sm font-medium mb-1 text-gray-300">Intelligence</label>
                      <input
                        v-model.number="newMerchant.stats.int"
                        type="number"
                        min="0"
                        class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                      />
                    </div>
                    <div>
                      <label class="block text-sm font-medium mb-1 text-gray-300">Agility</label>
                      <input
                        v-model.number="newMerchant.stats.agi"
                        type="number"
                        min="0"
                        class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                      />
                    </div>
                    <div>
                      <label class="block text-sm font-medium mb-1 text-gray-300">Defense</label>
                      <input
                        v-model.number="newMerchant.stats.defense"
                        type="number"
                        min="0"
                        class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                      />
                    </div>
                    <div>
                      <label class="block text-sm font-medium mb-1 text-gray-300">Luck</label>
                      <input
                        v-model.number="newMerchant.stats.luck"
                        type="number"
                        min="0"
                        class="w-full px-3 py-2 bg-gray-700 rounded-lg text-white border border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <!-- ปุ่มควบคุม -->
              <div class="flex justify-end gap-3">
                <button 
                  type="submit"
                  class="px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 transition duration-200"
                >
                  เพิ่มพ่อค้าเร่
                </button>
                <button 
                  @click="$emit('cancelModal')" 
                  type="button" 
                  class="px-4 py-2 bg-gray-600 text-white rounded-lg hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-500 transition duration-200"
                >
                  ยกเลิก
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue';
import { projectFirestore } from '@/firebase/config';

export default {
  emits: ['cancelModal', 'merchantAdded'],
  setup(props, { emit }) {
    const newMerchant = ref({
      name: '',
      img: '',
      normalFace: '',
      angryFace: '',
      phrases: [''],
      items: [{ name: '', price: 0, currency: 'silver', transferable: false }],
      locations: [''],
      allowRob: false,
      robRewards: { silver: 0, gold: 0, diamond: 0 },
      stats: {
        stamina: 0,
        str: 0,
        int: 0,
        agi: 0,
        defense: 0,
        luck: 0,
      },
      rarity: 1,
      createdAt: new Date()
    });

    // Get rarity colors based on rarity value
    const getRarityColors = (rarityValue) => {
      switch (Number(rarityValue)) {
        case 1: return { bgColor: 'bg-gray-500', textColor: 'text-gray-500', borderColor: 'border-gray-600' };
        case 2: return { bgColor: 'bg-stone-500', textColor: 'text-stone-500', borderColor: 'border-stone-600' };
        case 3: return { bgColor: 'bg-green-500', textColor: 'text-green-500', borderColor: 'border-green-600' };
        case 4: return { bgColor: 'bg-blue-500', textColor: 'text-blue-500', borderColor: 'border-blue-600' };
        case 5: return { bgColor: 'bg-red-500', textColor: 'text-red-500', borderColor: 'border-red-600' };
        default: return { bgColor: 'bg-gray-700', textColor: 'text-gray-500', borderColor: 'border-gray-600' };
      }
    };

    // Phrases
    const addPhrase = () => {
      newMerchant.value.phrases.push('');
    };

    const removePhrase = (index) => {
      if (newMerchant.value.phrases.length > 1) {
        newMerchant.value.phrases.splice(index, 1);
      }
    };

    // Items
    const addItem = () => {
      newMerchant.value.items.push({ name: '', price: 0, currency: 'silver', transferable: false });
    };

    const removeItem = (index) => {
      if (newMerchant.value.items.length > 1) {
        newMerchant.value.items.splice(index, 1);
      }
    };

    // Locations
    const addLocation = () => {
      newMerchant.value.locations.push('');
    };

    const removeLocation = (index) => {
      if (newMerchant.value.locations.length > 1) {
        newMerchant.value.locations.splice(index, 1);
      }
    };

    // Handle adding new merchant
    const handleAddMerchant = async () => {
      try {
        const merchantName = newMerchant.value.name.trim();
        if (!merchantName || /[/\.#$$$  $$]/.test(merchantName)) {
          alert('ชื่อพ่อค้าเร่ไม่ถูกต้อง ห้ามใช้ / . # $ [ ] หรือปล่อยว่าง');
          return;
        }

        // ตรวจสอบว่ามีชื่อพ่อค้าซ้ำหรือไม่
        const docRef = projectFirestore.collection('gameMerchants').doc(merchantName);
        const docSnap = await docRef.get();
        if (docSnap.exists) {
          alert('ชื่อพ่อค้าเร่นี้มีอยู่แล้ว ไม่สามารถสร้างซ้ำได้');
          return;
        }

        const rarityColors = getRarityColors(newMerchant.value.rarity);

        // Filter valid phrases
        const filteredPhrases = newMerchant.value.phrases.filter(phrase => phrase.trim());

        // Filter valid items
        const filteredItems = newMerchant.value.items.filter(item => item.name && item.price > 0);

        // Filter valid locations
        const filteredLocations = newMerchant.value.locations.filter(location => location.trim());

        const newMerchantData = {
          name: merchantName,
          img: newMerchant.value.img,
          normalFace: newMerchant.value.normalFace || '',
          angryFace: newMerchant.value.angryFace || '',
          phrases: filteredPhrases,
          items: filteredItems,
          itemNames: filteredItems.map(item => item.name),
          locations: filteredLocations,
          allowRob: newMerchant.value.allowRob,
          robRewards: newMerchant.value.allowRob ? newMerchant.value.robRewards : { silver: 0, gold: 0, diamond: 0 },
          stats: newMerchant.value.allowRob ? {
            stamina: newMerchant.value.stats.stamina,
            str: newMerchant.value.stats.str,
            int: newMerchant.value.stats.int,
            agi: newMerchant.value.stats.agi,
            defense: newMerchant.value.stats.defense,
            luck: newMerchant.value.stats.luck,
          } : { stamina: 0, str: 0, int: 0, agi: 0, defense: 0, luck: 0 },
          rarity: Number(newMerchant.value.rarity),
          rarityColors: rarityColors,
          createdAt: new Date()
        };

        // Add merchant to gameMerchants collection
        await projectFirestore.collection('gameMerchants').doc(merchantName).set(newMerchantData);

        console.log('Merchant added successfully:', merchantName);
        emit('merchantAdded');
        emit('cancelModal');
      } catch (error) {
        console.error('Error adding merchant:', error);
        alert(`เกิดข้อผิดพลาด: ${error.message}`);
      }
    };

    return { 
      newMerchant,
      handleAddMerchant,
      addPhrase,
      removePhrase,
      addItem,
      removeItem,
      addLocation,
      removeLocation
    };
  }
};
</script>

<style scoped>
.animate-fade-in {
  animation: fadeIn 0.3s ease-in;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>